// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+0ITF","title":"styles_title__uKIil","input":"styles_input__5Wspu"};